// The company's brand on its documents (backend/brand.py; design_handoff_founder_assistant screen 7): hex colours, the
// WCAG contrast rule the backend enforces (a main colour reads on white at 4.5:1 at least), and the colours a document
// uses, worked out from the main and accent ones. backend/tests/test_brand.py checks this file agrees with brand.py.

export const MIN_CONTRAST = 4.5;
export const WHITE = "#FFFFFF";
// a document's own text colour, and the neutral look a company without a brand gets
export const DOC_TEXT = "#1A1F1C";
export const NEUTRAL = { main: "#1A1F1C", accent: "#5C6560", tint: "#F0F1F0", foot: "#2B2E2C", footMuted: "#C4C8C5" };

// "#1f5e4b", "1F5E4B" or "#1f5" as "#1F5E4B"; "" as null; anything else as undefined (not a colour)
export function hexColour(value) {
  const v = (value || "").trim();
  if (!v) return null;
  const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(v);
  if (!m) return undefined;
  const digits = m[1].length === 3 ? m[1].split("").map((c) => c + c).join("") : m[1];
  return `#${digits.toUpperCase()}`;
}

const rgb = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
const channel = (c) => { const s = c / 255; return s <= 0.04045 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4; };

export function luminance(hex) {
  const [r, g, b] = rgb(hex).map(channel);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

// WCAG 2 contrast ratio between two "#RRGGBB" colours, 1 to 21
export function contrast(a, b) {
  const [hi, lo] = [luminance(a), luminance(b)].sort((x, y) => y - x);
  return (hi + 0.05) / (lo + 0.05);
}

// "7.6": one decimal, and a ratio under the minimum never shows as reaching it (4.46 is "4.4")
export function ratioLabel(ratio) {
  const shown = Math.round(ratio * 10) / 10;
  return (ratio < MIN_CONTRAST ? Math.min(shown, MIN_CONTRAST - 0.1) : shown).toFixed(1);
}

const hex = (c) => `#${c.map((v) => Math.round(Math.max(0, Math.min(255, v))).toString(16).padStart(2, "0")).join("").toUpperCase()}`;
// `t` of the way from colour a to colour b
export const mix = (a, b, t) => hex(rgb(a).map((v, i) => v * (1 - t) + rgb(b)[i] * t));

// What a document is drawn with (light email and PDF): headings and numbers in the main colour, a tinted band, a footer
// band in the main colour darkened with white and a soft white on it, and the accent for small marks. A company
// without a main colour gets the neutral look; without an accent, the main colour does its job.
export function palette({ main, accent } = {}) {
  if (!main) return { ...NEUTRAL, accent: accent || NEUTRAL.accent };
  return { main, accent: accent || main, tint: mix(WHITE, main, 0.09), foot: mix(main, "#000000", 0.4), footMuted: mix(WHITE, main, 0.32) };
}
